import { render, staticRenderFns } from "./actualDialog.vue?vue&type=template&id=a31d63b0&"
import script from "./actualDialog.vue?vue&type=script&lang=js&"
export * from "./actualDialog.vue?vue&type=script&lang=js&"
import style0 from "./actualDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a31d63b0')) {
      api.createRecord('a31d63b0', component.options)
    } else {
      api.reload('a31d63b0', component.options)
    }
    module.hot.accept("./actualDialog.vue?vue&type=template&id=a31d63b0&", function () {
      api.rerender('a31d63b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/clRealSendReceive/actualDialog.vue"
export default component.exports